import css from './HomePage.module.css';

import { Box, Grid, IconButton, Skeleton } from "@mui/material";
import React from "react";
import { TbLicenseOff, TbReload } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { ActivationCard } from "../../components/ActivationCard/ActivationCard";
import { EmptyState } from "../../components/EmptyState/EmptyState";
import { routes } from "../../constants/appRoutes";
import { ActivationDTO, GetActivations } from '../../helpers/activations.services';

const useActivations = () => {

    const navigate = useNavigate();

    const [activations, setActivations] = React.useState<ActivationDTO[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const onReloadActivations = () => {

        setIsLoading(true);
        GetActivations()
            .then((res) => {

                setActivations(res.data.activations || []);

            }).catch((res) => {

                const code = res?.response?.status || 500;
                
                if (String(code) === "401") {

                    window.location.href = "/Account/OnPostLogin";
                } else if (String(code) === "404") {

                    navigate(`/errors/${routes.statusCode404}`, { replace: true });
                } else {

                    navigate(`/errors`, { state: { code } });
                }
            }).finally(() => {

                setIsLoading(false);

            });
    }

    React.useEffect(() => {

        onReloadActivations();
    }, []);

    return {
        activations,
        isLoading,
        onReloadActivations
    }
}

export const HomePage = () => {

    const {
        activations,
        isLoading,
        onReloadActivations
    } = useActivations();

    const HomePageSkeleton = () => (
        <Grid xs={12} spacing={2} container item>
            {[...Array(6)].map((_, i) => (
                <Grid key={`home-page-skeleton-${i}`} xs={12} sm={12} md={6} lg={4} item>
                    <Box className={css.skeletonContainer}>
                        <Skeleton variant="rectangular" />
                    </Box>
                </Grid>
            ))}
        </Grid>
    );

    return (
        <Box className={css.homePageContainer}>
            <Grid spacing={2} container>
                <Grid xs={12} item>
                    <IconButton
                        disabled={isLoading}
                        onClick={onReloadActivations}
                    >
                        <TbReload />
                    </IconButton>
                </Grid>
                {isLoading ?
                    <HomePageSkeleton /> :
                    (activations.length ?
                        (
                            activations.sort((a, b) => a.companyName.localeCompare(b.companyName)).map((activation, key) => {
                                return (
                                    <Grid key={`activation-${key}`} xs={12} md={6} lg={4} item>
                                        <ActivationCard {...activation} onRefreshActivations={onReloadActivations} />
                                    </Grid>
                                )
                            })
                        ) :
                        (
                            <Grid xs={12} item>
                                <EmptyState
                                    title="Non ci sono attivazioni valide per l'utente"
                                    icon={<TbLicenseOff />}
                                />
                            </Grid>
                        ))
                }
            </Grid>
        </Box>
    );
};
